import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export function PageTransition({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const [display, setDisplay] = useState(children);
  const [phase, setPhase] = useState<"enter" | "exit">("enter");
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname !== prevPath.current) {
      // Start exit
      setPhase("exit");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (phase === "exit") {
      const timer = setTimeout(() => {
        setDisplay(children);
        prevPath.current = location.pathname;
        setPhase("enter");
      }, 150); // exit duration
      return () => clearTimeout(timer);
    }
  }, [phase, children, location.pathname]);

  return (
    <div
      className={
        phase === "enter"
          ? "animate-in fade-in slide-in-from-bottom-1 duration-200 fill-mode-both motion-reduce:animate-none"
          : "animate-out fade-out slide-out-to-top-1 duration-150 fill-mode-both"
      }
      style={{ animationTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)" }}
    >
      {display}
    </div>
  );
}
